module.exports = __webpack_public_path__ + "static/sheath-9a6e9dde38f6f97557c9196c2ff8ba93.png";